/**
 * @format
 */
import { api } from '@/scripts/api';

export const SolutionRoadmapService = {
    getRoadmapData(companyId) {
        return new Promise((resolve, reject) => {
            const service = `/api/Company/${companyId}/SolutionsRoadmap`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getBreakdownData(companyId) {
        return new Promise((resolve, reject) => {
            const service = `/api/Company/${companyId}/SolutionsBreakdown`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getUnsoldSolutions(companyId, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/UnsoldSolutions';
            const endpoint = api.applyODataParams(service, {
                ...config,
                count: true,
                expand: 'Bundles($select=Id,Name,ImageUrl)',
                noOdata: `companyId=${companyId}`,
            });

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    assign(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/Companies/AddSolutions';
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    remove(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/Companies/RemoveSolutions';
            api.msPatch(service, payload).then(resolve).catch(reject);
        });
    },
};
